import {useQuery} from "react-query";
import {getConsommationLTE} from '../Api/api';
import {ConsommationLTE} from '../Types/service';

export const useGetConsommation = (cisId: string) => {
  return useQuery<any, any, ConsommationLTE>(
      ['ConsommationLTE', cisId],
      () => getConsommationLTE(cisId)
    );
}
